import React from 'react';
import { Select } from '@/presentation/components';
import { PayItem } from '../PayItem';
import Spinner from '@/presentation/components/Spinner';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import PaymentContainer from '../ContainerPayments';
import EmptyDataStateMessage from '@/presentation/reusables/EmptyDataStateMessage';
import { formatAmount } from '../../modules/PayOnline/helpers';

interface PeriodOption {
  value: string;
  label: string;
}

interface PaymentItem {
  itemNumber: string;
  name: string;
  amount: string;
  dueDate: number;
  dateCreate: number;
  billingDate?: number;
  status: string;
  paymentType: {
    id: string;
    desc: string;
  };
  hasDiscountProntoPago?: boolean;
  recharge?: string;
  periodDesc?: string;
  amountToPay?: string;
  amountWithBenefits?: string;
  billName?: string;
  discountProntoPago?: number;
  discountCicloCompleto?: number;
  discountBene?: number;
  datePayment?: number;
}

interface PaymentHistorialViewProps {
  data: PaymentItem[];
  periods: PeriodOption[];
  dataLoading: boolean;
  handleBack: () => void;
  selectedPeriod: any;
  onPeriodChange: (item: any) => void;
}

const PaymentHistorialView: React.FC<PaymentHistorialViewProps> = ({
  data,
  periods,
  dataLoading,
  handleBack,
  selectedPeriod,
  onPeriodChange
}) => (
  <PaymentContainer>
    <div>
      <SubsectionHeader title="Historial de pagos" onClick={handleBack} />
      <div>Periodo</div>
      <div style={{ marginBottom: '16px', maxWidth: '328px' }}>
        <Select
          options={periods}
          placeholder="Elige el ciclo"
          handleChangeSelect={onPeriodChange}
          data-testid="cmp-select-1"
          value={selectedPeriod || ''}
          isDisabled={periods.length === 0 || dataLoading}
        />
      </div>

      {dataLoading ? (
        <Spinner />
      ) : (
        data.map((item) => (
          <PayItem
            key={item.itemNumber}
            itemNumber={item.itemNumber}
            name={item.name}
            amount={item.amount}
            dueDate={item.dueDate}
            dateCreate={item.dateCreate}
            billingDate={item?.billingDate}
            datePayment={item?.datePayment}
            status={item.status}
            paymentType={item.paymentType}
            hasDiscountProntoPago={item.hasDiscountProntoPago}
            recharge={item.recharge}
            periodDesc={item.periodDesc}
            amountToPay={item.amountToPay ?? ''}
            amountToPayStr={formatAmount(item.amountToPay ?? '')}
            amountWithBenefits={item.amountWithBenefits}
            billName={item.billName}
            discountProntoPago={item.discountProntoPago}
            discountCicloCompleto={item.discountCicloCompleto}
            discountBene={item.discountBene}
          />
        ))
      )}

      {!dataLoading && data.length === 0 && (
        <EmptyDataStateMessage message="No se encontraron datos de pagos para este periodo" />
      )}
    </div>
  </PaymentContainer>
);

export default PaymentHistorialView;
